import { gql } from '__generated__';

export default gql(`
  query GetParticipantSentMails($project_id: ID!, $participant_id: ID!) {
    project(id: $project_id) {
      id
      participant(id: $participant_id) {
        id
        sent_mails {
          id
          to
          subject
          created_at
          sent_mail_attachments {
            id
            filename
          }
        }
      }
    }
  }
`);
